import api from '../utilities/api';

export default {
    onboardingSession(token) {
        return api.v2.get(`auth/onboarding/${token}`);
    },
    completeOnboarding(token, password, governingBody) {
        return api.v2.post(`auth/onboarding/${token}`, {password: password, governingBody: governingBody});
    },
    forgotPasswordComplete(token, password) {
        return api.v2.post(`auth/password-reset/${token}`, {password: password});
    }
}
